module.exports = __webpack_public_path__ + "static/media/23.46aabc80.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/poinkos/23.jpg
// module id = 556
// module chunks = 0